import { tryParseNumber } from '../parse/parse-int';
export var formatCurrency = function (value) {
    var amount = tryParseNumber(value);
    var formattedAmount = Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' });
    var values = formattedAmount.format(amount).split('£');
    return (values === null || values === void 0 ? void 0 : values.length) > 0 ? values[1] : amount.toString();
};
